<template>
  <div class="video">
    <div id="dplayer"></div>
  </div>
</template>

<script>
import DPlayer from "dplayer";
export default {
  name: "crouseVideo",
  props: {
    info: Object,
  },
  data() {
    return {};
  },
  watch: {
    info(val) {
      this.dp.switchVideo({
        url: val.videoUrl,
      });
      if (!val.videoUrl) this.$message.warning("本章节无视频");
    },
  },
  mounted() {
    this.dp = new DPlayer({
      container: document.getElementById("dplayer"),
      video: {
        type: "hls",
      },
    });
    if (this.info.videoUrl) {
      this.dp.switchVideo({
        url: this.info.videoUrl,
      });
    }
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.video {
  width: 100%;
  height: 100%;

  #dplayer {
    width: 100%;
    height: 100%;
  }
}
</style>